import React, { Component } from 'react';
import Square from './Square.jsx';
import HomeTab from './HomeTab.jsx';
import InstructionsTab from './InstructionsTab.jsx';
import AssessSection from './AssessSection.jsx';
import PrescribeTab from './PrescribeTab.jsx';
import CoachSection from './CoachSection.jsx';
import AboutSection from './AboutSection.jsx';

import regression from 'regression';



export default class Board extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tabName: ['Home', 'Instructions', 'Assess', 'Prescribe', 'Coach'],
            activeTab: 'Home',

            // values to be stored in parent from Assess Tab
            bodyWeight: 90,
            togglePullPush: true, //pull is set
            toggleMetImp: true, // metric is set 
            resistedLoad0: 0,
            resistedLoad1: 31.5,
            resistedLoad2: 58.5,
            resistedLoad3: 90,
            resistedLoadPercentage0: 0,
            resistedLoadPercentage1: 35,
            resistedLoadPercentage2: 65,
            resistedLoadPercentage3: 100,
            slopeValue: 0,
            interceptValue: 0,
            rsquaredValue: 0,
            vel0: 0,
            vel1: 0,
            vel2: 0,
            vel3: 0,
            vMPS0: 0,
            vMPS1: 0,
            vMPS2: 0,
            vMPS3: 0,
            velocityStringUnits: "(kph)",
            bodyWeightUnitString: "(kg)",
            // Prescribe section with training zone buttons and slider
            defaultActiveTrainingZone: "Technical Competency",
            trainingButtonCurrentColors: ['#558bf0', '#555555', '#555555', '#555555'],
            trainingButtonCurrentClasses: ['trainingZoneButtonBlueFocus', 'trainingZoneButtonGreen', 'trainingZoneButtonYellow', 'trainingZoneButtonRed'],
            minSliderValue: 0,
            maxSliderValue: 10,
            currentSliderValue: 5,
            //secondTickValue: 2.5,
            //thirdTickValue: 5,
            //fourthTickValue: 7.5,
            explanation: "Add resistance with minimal disruption to sprint mechanics",

        };

        this.settingStateInParent = this.settingStateInParent.bind(this);
        this.myTogglePushPullCallback = this.myTogglePushPullCallback.bind(this);
        this.calculateLoadFromPercentage = this.calculateLoadFromPercentage.bind(this);
        this.calculateSlopeAndIntercept = this.calculateSlopeAndIntercept.bind(this);
    }


    handleClick(i) {
        const tabNameString = this.state.tabName;
        var activeTab
        activeTab = tabNameString[i];
        this.setState({ activeTab: activeTab })
    }

    renderSquare(i) {
        return (
            <Square
                text={this.state.tabName[i]}
                activeTabText={this.state.activeTab}
                onClick={() => this.handleClick(i)}
            />
        );
    }


    settingStateInParent(value, name) {
        this.setState({ [name]: value });
    }

    myTogglePushPullCallback(value, name) {
        this.setState({ [name]: value });
        const { bodyWeight, vMPS0, vMPS1, vMPS2, vMPS3 } = this.state;
        var { resistedLoad0, resistedLoad1, resistedLoad2, resistedLoad3 } = [];

        // same for push and pull
        resistedLoad0 = this.calculateLoadFromPercentage(0, bodyWeight);
        resistedLoad1 = this.calculateLoadFromPercentage(35, bodyWeight);
        resistedLoad2 = this.calculateLoadFromPercentage(65, bodyWeight);
        resistedLoad3 = this.calculateLoadFromPercentage(100, bodyWeight);
        this.setState({ resistedLoadPercentage0: 0 })
        this.setState({ resistedLoadPercentage1: 35 })
        this.setState({ resistedLoadPercentage2: 65 })
        this.setState({ resistedLoadPercentage3: 100 })

        if (value) {

            this.setState({ defaultActiveTrainingZone: "Technical Competency" })
            this.setState({ defaultActiveTrainingZone: "Speed Strength" })
            this.setState({ trainingButtonCurrentClasses: ['trainingZoneButtonBlueFocus', 'trainingZoneButtonGreen', 'trainingZoneButtonYellow', 'trainingZoneButtonRed'] })
            this.setState({ trainingButtonCurrentColors: ['#558bf0', '#555555', '#555555', '#555555'] })
            this.setState({ minSliderValue: 0 })
            this.setState({ maxSliderValue: 10 })
            this.setState({ currentSliderValue: 5 })
            this.setState({ explanation: "Add resistance with minimal disruption to sprint mechanics" })
        }
        else {

            this.setState({ defaultActiveTrainingZone: "Speed Strength" })
            this.setState({ trainingButtonCurrentClasses: ['trainingZoneButtonBlue', 'trainingZoneButtonGreenFocus', 'trainingZoneButtonYellow', 'trainingZoneButtonRed'] })
            this.setState({ trainingButtonCurrentColors: ['#555555', '#52de52', '#555555', '#555555'] })
            this.setState({ minSliderValue: 10 })
            this.setState({ maxSliderValue: 35 })
            this.setState({ currentSliderValue: 22.5 })
            this.setState({ explanation: "Improve force production capability during transition to Vmax" })

        }

        this.setState({ resistedLoad0: resistedLoad0 })
        this.setState({ resistedLoad1: resistedLoad1 })
        this.setState({ resistedLoad2: resistedLoad2 })
        this.setState({ resistedLoad3: resistedLoad3 })

        this.calculateSlopeAndIntercept(vMPS0, vMPS1, vMPS2, vMPS3, resistedLoad1, resistedLoad2, resistedLoad3);

    }

    calculateLoadFromPercentage = (loadPercentage, bodyWeight) => {
        const loadFromPercentage = loadPercentage / 100 * bodyWeight;
        return loadFromPercentage;
    }

    calculateSlopeAndIntercept = (vMPS0, vMPS1, vMPS2, vMPS3, resistedLoad1, resistedLoad2, resistedLoad3) => {
        const resistedLoad0 = this.state.resistedLoad0;
        var { result, gradient, yIntercept, rsquared } = [];



        if (vMPS0 !== 0 && vMPS1 !== 0 && vMPS2 !== 0 && vMPS3 !== 0) {

            result = regression.linear([[resistedLoad0, vMPS0], [resistedLoad1, vMPS1], [resistedLoad2, vMPS2], [resistedLoad3, vMPS3]], { precision: 5 });

            gradient = Number(result.equation[0]);
            yIntercept = Number(result.equation[1]);
            rsquared = Number(result.r2);
        }
        else {
            gradient = 0;
            yIntercept = 0;
            rsquared = 0;

        }


        // set states in this component for children
        this.setState({ interceptValue: yIntercept })
        this.setState({ slopeValue: gradient })
        this.setState({ rsquaredValue: rsquared })

    }


    renderTab() {
        return (
            <div>
                <HomeTab
                    settingStateInParent={this.myTogglePushPullCallback}
                    togglePullPush={this.state.togglePullPush}
                />
                <InstructionsTab />
                <AssessSection
                    settingStateInParent={this.settingStateInParent}
                    calculateLoadFromPercentage={this.calculateLoadFromPercentage}
                    calculateSlopeAndIntercept={this.calculateSlopeAndIntercept}
                    bodyWeight={this.state.bodyWeight}
                    togglePullPush={this.state.togglePullPush}
                    toggleMetImp={this.state.toggleMetImp}
                    velocityStringUnits={this.state.velocityStringUnits}
                    bodyWeightUnitString={this.state.bodyWeightUnitString}
                    resistedLoad0={this.state.resistedLoad0}
                    resistedLoad1={this.state.resistedLoad1}
                    resistedLoad2={this.state.resistedLoad2}
                    resistedLoad3={this.state.resistedLoad3}
                    resistedLoadPercentage0={this.state.resistedLoadPercentage0}
                    resistedLoadPercentage1={this.state.resistedLoadPercentage1}
                    resistedLoadPercentage2={this.state.resistedLoadPercentage2}
                    resistedLoadPercentage3={this.state.resistedLoadPercentage3}
                    vel0={this.state.vel0}
                    vel1={this.state.vel1}
                    vel2={this.state.vel2}
                    vel3={this.state.vel3}
                    vMPS0={this.state.vMPS0}
                    vMPS1={this.state.vMPS1}
                    vMPS2={this.state.vMPS2}
                    vMPS3={this.state.vMPS3}
                    slopeValue={this.state.slopeValue}
                    interceptValue={this.state.interceptValue}
                    rsquaredValue={this.state.rsquaredValue}
                />
                <PrescribeTab
                    settingStateInParent={this.settingStateInParent}
                    togglePullPush={this.state.togglePullPush}
                    slopeValue={this.state.slopeValue}
                    interceptValue={this.state.interceptValue}
                    vMPS0={this.state.vMPS0}
                    vMPS1={this.state.vMPS1}
                    vMPS2={this.state.vMPS2}
                    vMPS3={this.state.vMPS3}
                    bodyWeightUnitString={this.state.bodyWeightUnitString}
                    defaultActiveTrainingZone={this.state.defaultActiveTrainingZone}
                    trainingButtonCurrentClasses={this.state.trainingButtonCurrentClasses}
                    trainingButtonCurrentColors={this.state.trainingButtonCurrentColors}
                    minSliderValue={this.state.minSliderValue}
                    maxSliderValue={this.state.maxSliderValue}
                    currentSliderValue={this.state.currentSliderValue}
                    explanation={this.state.explanation}
                //secondTickValue={this.state.secondTickValue}
                //thirdTickValue={this.state.thirdTickValue}
                //fourthTickValue={this.state.fourthTickValue}
                />
                <CoachSection
                    activeTrainingZone={this.state.defaultActiveTrainingZone}
                />
                < AboutSection />
            </div>
        );
    }

    render() {
        return (
            this.renderTab()
        );
    }
}

//<div className="headerBar">
//    <h1 className="heading1">RESISTED SLED TRAINING</h1>
//    <h2 >Miche{'\u00E1'}l Cahill PhD</h2>
//</div>

